interface XProps {
  className?: string;
}

export default function X({ className }: XProps) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
    >
      <path
        d='M23.4142 11.4142C24.1953 10.6332 24.1953 9.36683 23.4142 8.58579C22.6332 7.80474 21.3668 7.80474 20.5858 8.58579L16 13.1716L11.4142 8.58579C10.6332 7.80474 9.36683 7.80474 8.58579 8.58579C7.80474 9.36683 7.80474 10.6332 8.58579 11.4142L13.1716 16L8.58579 20.5858C7.80474 21.3668 7.80474 22.6332 8.58579 23.4142C9.36684 24.1953 10.6332 24.1953 11.4142 23.4142L16 18.8284L20.5858 23.4142C21.3668 24.1953 22.6332 24.1953 23.4142 23.4142C24.1953 22.6332 24.1953 21.3668 23.4142 20.5858L18.8284 16L23.4142 11.4142Z'
        fill='#232426'
      />
    </svg>
  );
}
